import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable()
export class AuditHttp {
  constructor(protected httpService: HttpService) {}

  navigationAudit = async activity => await this.httpService.post(`/account/activity?activityType=${activity}`);

  getDailyAccessData = async (from, to) => await this.httpService.get(`/dashboard/daily-access-data?from=${from}&to=${to}`);

  getAuditData = async (activity, searchKey, page, size, sort) =>
    await this.httpService.get(
      `/dashboard/audit-data?activity=${activity}&search=${searchKey}&page=${page}&size=${size}${(sort && '&sort=' + sort) || ''}`
    );

  getAuditDataCount = async (activity, searchKey, page, size, sort) =>
    await this.httpService.get(
      `/dashboard/audit-data/count?activity=${activity}&search=${searchKey}&page=${page}&size=${size}${(sort && '&sort=' + sort) || ''}`
    );

  getTotalAccessData = async () => await this.httpService.get(`/dashboard/total-access-data`);
}

@Injectable()
export class AuditService {
  constructor(protected http: AuditHttp) {}

  async navigationAudit(activity) {
    await this.http.navigationAudit(activity);
  }

  async getTotalAccessData() {
    return await this.http.getTotalAccessData();
  }

  async getDailyAccessData(from, to) {
    return await this.http.getDailyAccessData(from, to);
  }

  async getAuditDataCount(activity, searchKey, page, size, sort) {
    return await this.http.getAuditDataCount(activity, searchKey, page, size, sort);
  }

  async getAuditData(activity, searchKey, page, size, sort) {
    return await this.http.getAuditData(activity, searchKey, page, size, sort);
  }
}

export enum Activity {
  ALL = 'ALL',
  ACCESS_COMPANY_SYNOPSIS = 'ACCESS_COMPANY_SYNOPSIS',
  ACCESS_RESEARCH_REPORTS = 'ACCESS_RESEARCH_REPORTS',
  ACCESS_DIY_STOCK_ANALYZER = 'ACCESS_DIY_STOCK_ANALYZER',
  ACCESS_RECOMMENDATIONS = 'ACCESS_RECOMMENDATIONS',
  ACCESS_MARKET_BUZZ = 'ACCESS_MARKET_BUZZ',
  ACCESS_DATA_LIBRARY = 'ACCESS_DATA_LIBRARY',
  ACCESS_HISTORICAL_SHARE_STATISTICS = 'ACCESS_HISTORICAL_SHARE_STATISTICS',
  ACCESS_SECTOR_STATISTICS = 'ACCESS_SECTOR_STATISTICS',
  ACCESS_MARKET_DATA = 'ACCESS_MARKET_DATA',
  ACCESS_CORPORATE_ANNOUNCEMENTS = 'ACCESS_CORPORATE_ANNOUNCEMENTS',
  ACCESS_KEY_ECONOMIC_DATA = 'ACCESS_KEY_ECONOMIC_DATA',
  LOG_IN = 'LOG_IN',
  UPLOAD_REPORT = 'UPLOAD_REPORT',
  DELETE_REPORT = 'DELETE_REPORT',
  DOWNLOAD_REPORT_SECTOR_STAT = 'DOWNLOAD_REPORT_SECTOR_STAT'
}

export const ActivityTypes = [
  { type: Activity.ALL, name: 'All' },
  { type: Activity.ACCESS_COMPANY_SYNOPSIS, name: 'Company Synopsis' },
  { type: Activity.ACCESS_RESEARCH_REPORTS, name: 'Research Report' },
  { type: Activity.ACCESS_DIY_STOCK_ANALYZER, name: 'DIY Stock Analyzer' },
  { type: Activity.ACCESS_RECOMMENDATIONS, name: 'Recommendation' },
  { type: Activity.ACCESS_MARKET_BUZZ, name: 'Company News' },
  { type: Activity.ACCESS_DATA_LIBRARY, name: 'Data Library' },
  { type: Activity.ACCESS_HISTORICAL_SHARE_STATISTICS, name: 'Historical Share Statistics' },
  { type: Activity.ACCESS_SECTOR_STATISTICS, name: 'Sector Statistics' },
  { type: Activity.ACCESS_MARKET_DATA, name: 'Market Data' },
  { type: Activity.ACCESS_CORPORATE_ANNOUNCEMENTS, name: 'Corporate Announcements' },
  { type: Activity.ACCESS_KEY_ECONOMIC_DATA, name: 'Key Economic data' },
  { type: Activity.LOG_IN, name: 'Log In' },
  { type: Activity.UPLOAD_REPORT, name: 'Upload Report' },
  { type: Activity.DELETE_REPORT, name: 'Delete Report' }
  // { type: Activity.DOWNLOAD_REPORT_SECTOR_STAT, name: 'Download Report Sector Stat' }
];
